import { useEffect, useState } from 'react';
import useConfigStore from '@/stores/useConfigStore';
import { EventData } from '@/shared/config';

/**
 * Hook to manage event configuration data fetched from the API
 * Provides the current event configuration including in-person session availability
 */
export function useEventConfiguration() {
  const [eventData, setEventData] = useState<EventData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const loadEventConfiguration = useConfigStore(
    (state) => state.loadEventConfiguration,
  );

  useEffect(() => {
    const loadEventData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await loadEventConfiguration();
        setEventData(data);
      } catch (err) {
        const error =
          err instanceof Error
            ? err
            : new Error('Failed to load event configuration');
        setError(error);
        console.error('Failed to load event configuration:', error);
        // Set fallback event data
        setEventData({
          inPersonEventSessions: false,
          eventPeriods: [],
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadEventData();
  }, [loadEventConfiguration]);

  return {
    eventData,
    isLoading,
    error,
    inPersonEventSessions: eventData?.inPersonEventSessions ?? false,
    eventPeriods: eventData?.eventPeriods ?? [],
  };
}
